import { Box, Grid, Typography, Checkbox, MenuItem, IconButton, Button } from "@mui/material";
import React, { useEffect } from "react";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DescriptionIcon from "@mui/icons-material/Description";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { z } from "zod";
import { useTMutation } from "../../../../../utils/useTMutation";
import showToast from "../../../../../components/Hot-Toast/showToast";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const fieldSchema = z.object({
    copyDocument: z.boolean().default(false),
    issueDate: z.boolean().default(false),
    expirationDate: z.boolean().default(false),
    notes: z.boolean().default(false),
});

export default function RequiredFields() {
    const { values } = useSelector((state) => state?.multiStep);
    const navigate = useNavigate();

    const {
        handleSubmit,
        reset,
        control,
    } = useForm({
        resolver: zodResolver(fieldSchema),
        defaultValues: {
            copyDocument: false,
            issueDate: false,
            expirationDate: false,
            notes: false,
        },
    });

    useEffect(() => {
        if (values) {
            reset({
                copyDocument: !!values?.copyDocument,
                issueDate: !!values?.issueDate,
                expirationDate: !!values?.expiration,
                notes: !!values?.notes,
            });
        }
    }, [values, reset]);

    const { mutateAsync } = useTMutation("/addCertificate", "post", (data) => {
        if (data.STATUS) return data;
        showToast("error", data.MESSAGE, 3000);
    });

    const submitFormData = async (formData) => {
        const transformedData = {
            copyDocument: formData.copyDocument ? 1 : 0,
            issueDate: formData.issueDate ? 1 : 0,
            expirationDate: formData.expirationDate ? 1 : 0,
            notes: formData.notes ? 1 : 0,
        };

        try {
            const response = await mutateAsync({
                transformedData,
                ID: values?.ID,
                JOBROLE_ID: values?.JOBROLE_ID,
            });

            if (response?.STATUS) {
                showToast("success", response.MESSAGE, 3000);
                navigate("/admin/profile-criteria/Certifications");
            } else {
                showToast("error", response.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const fields = [
        {
            name: "copyDocument",
            label: "Document copy",
            icon: <FileCopyIcon />,
            color: "#6ebe44",
        },
        {
            name: "issueDate",
            label: "Issue date",
            icon: <CalendarTodayIcon />,
            color: "#1ad1ff",
        },
        {
            name: "expirationDate",
            label: "Expiration date",
            icon: <CalendarTodayIcon />,
            color: "#ff8000",
        },
        {
            name: "notes",
            label: "Notes",
            icon: <DescriptionIcon />,
            color: "#ffaa00",
        },
    ];

    return (
        <Grid item>
            <Box px={1.6} mt={1.2}>
                <Typography variant="h1">Select the required fields</Typography>
            </Box>

            <form onSubmit={handleSubmit(submitFormData)}>
                <Box sx={{ m: 2 }}>
                    {fields.map((field) => (
                        <MenuItem key={field.name} sx={{ background: "#f5f5f5", mb: 1 }}>

                            <IconButton
                                sx={{
                                    background: field.color,
                                    color: "white",
                                    borderRadius: "100px",
                                    mr: 1,
                                }}
                            >
                                {field.icon}
                            </IconButton>

                            <Typography>{field.label}</Typography>

                            <Controller
                                name={field.name}
                                control={control}
                                render={({ field: controllerField }) => (
                                    <Checkbox
                                        checked={controllerField.value}
                                        onChange={(e) => controllerField.onChange(e.target.checked)}
                                        sx={{
                                            ml: "auto",
                                            color: "#6ebe44",
                                            "&.Mui-checked": {
                                                color: "#6ebe44",
                                            },
                                        }}
                                    />
                                )}
                            />
                        </MenuItem>
                    ))}
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}>
                    <Button
                        className="gradientAdminThemeColor"
                        type="submit"
                    >
                        Finish
                    </Button>
                </Box>
            </form>
        </Grid>
    );
}